const states = {
   name: '',//姓名
   avatar:'',//头像
   companyname:"",//公司名称
   vip_type:'',//版本
   vip_type_val: "",
   vip_log: ""
}
export default states